import React, { lazy, useEffect } from 'react'
import './App.css'
import { BrowserRouter as Router, useLocation } from 'react-router-dom'

import MarketingSiteApp from './pages/marketing/MarketingSiteApp'
const AuthenticatedApp = lazy(() => import('./AuthenticatedApp'))

const MARKETING_PATHS = new Set([
  '/',
  '/about',
  '/services',
  '/contact',
  '/waitlist',
  '/privacy-policy',
  '/terms',
])

const APP_PUBLIC_PATHS = new Set([
  '/login',
  '/provider/login',
  '/customer/login',
  '/forgot-password',
  '/register',
  '/documentation',
  '/provider/signup',
  '/customer/signup',
])

const APP_PROTECTED_PREFIXES = ['/app', '/provider', '/customer']

function ScrollToTop() {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
  }, [pathname])

  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      const previous = window.history.scrollRestoration
      window.history.scrollRestoration = 'manual'
      return () => {
        window.history.scrollRestoration = previous
      }
    }
    return undefined
  }, [])

  return null
}

function RouteSwitcher() {
  const location = useLocation()
  const { pathname } = location

  const isMarketingRoute = MARKETING_PATHS.has(pathname)
  const isAppPublicRoute = APP_PUBLIC_PATHS.has(pathname)
  const isAppProtectedRoute = APP_PROTECTED_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  )

  return isMarketingRoute || (!isAppPublicRoute && !isAppProtectedRoute) ? (
    <MarketingSiteApp />
  ) : (
    <AuthenticatedApp />
  )
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <RouteSwitcher />
    </Router>
  )
}

export default App
